module.exports = __webpack_public_path__ + "img/emptynotification.4f84c95e.svg";